/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfListOfLineTextReviewDto } from '../../models/platform-api-result-of-list-of-line-text-review-dto';

export interface GetLineTextReviews$Params {
}

export function getLineTextReviews(http: HttpClient, rootUrl: string, params?: GetLineTextReviews$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfLineTextReviewDto>> {
  const rb = new RequestBuilder(rootUrl, getLineTextReviews.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfListOfLineTextReviewDto>;
    })
  );
}

getLineTextReviews.PATH = '/api/line-text-reviews';
